import hexToRgba from "hex-rgba";
import commonTheme from "./common-theme";

const theme = {
  name: "barkio-dark",
  fonts: commonTheme.fonts,
  breakpoints: commonTheme.breakpoints,
  isDarkMode: true,
  colors: {
    ...commonTheme.colors,
    primary: "#6eb918",
    primaryLight: hexToRgba("#409100", 24),
    primaryLight2: hexToRgba("#409100", 32),
    primaryLighter: "#58a509",
    primaryDarker: "#3b8500",
    primaryBackground: "#409100",

    secondary: "#825f5f",
    secondaryLight: hexToRgba("#825f5f", 28),
    secondaryLight2: hexToRgba("#825f5f", 48),
    secondaryLighter: "#937877",
    secondaryDarker: "#775656",

    get highEmphasis() {
      return this.white;
    },
    get mediumEmphasis() {
      return this.white70;
    },
    get lowEmphasis() {
      return this.white40;
    },
    get outline() {
      return this.white20;
    },
    get outlineHover() {
      return this.white40;
    },
    get surface() {
      return "#121212";
    },
    get surfaceElevated1() {
      return "#2e2e2e";
    },
    get surfaceElevated2() {
      return "#3e3e3e";
    },
    get surfaceElevated3() {
      return "#525252";
    },
    get hover() {
      return this.white8;
    },
    get iconBackground() {
      return this.white12;
    },
    get overlay() {
      return this.black54;
    },

    warningBase: "#fb594c",
    warningLight: hexToRgba("#fb594c", 20),
    warningLight2: hexToRgba("#fb594c", 40),
    warningLighter: "#fb6a5e",
    warningDarker: "#e25044",

    tint1: "#fb6078",

    tint2: "#d8972b",
    tint2Light: hexToRgba("#d8972b", 18),

    tint3: "#0083c2",
    tint3Light: hexToRgba("#0083c2", 20),

    tint4: "#9e4bd9",
    tint4Light: hexToRgba("#9b1ff4", 24),

    "command-tint1": "#fb594c",

    "command-tint2": "#d77904",
    "command-tint2Light": hexToRgba("#f58900", 20),

    "command-tint3": "#969522",

    "command-tint4": "#019587",
    "command-tint4Light": hexToRgba("#00aa9a", 20),

    "command-tint5": "#0083c2",

    "command-tint6": "#4242e0",

    "command-tint7": "#9e4bd9",

    "command-tint8": "#c75d99",
    "command-tint8Light": hexToRgba("#c75d99", 20),

    tintRed: "#FB594C",
    tintOrange: "#D77904",
    tintYellow: "#D8972B",
    tintOlive: "#7F9312",
    tintGreen: "#409100",
    tintTurquoise: "#259287",
    tintBlue: "#0083C2",
    tintBlueLight: hexToRgba("#0083C2", 12),
    tintIndigo: "#405BE3",
    tintPurple: "#7C55F1",
    tintPink: "#C75D99",
    tintBrown: "#825F5F"
  }
};

export default theme;
